import React, { Component } from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import SelectedPlan from '../../components/SelectedPlan/SelectedPlan';
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { AiFillWarning } from "react-icons/ai";
import pack from '../../actions/pack';
import toastr from 'toastr';
import purchasedPack from '../../actions/purchasedPack'

class PlanChange extends Component {

    constructor(props){
        super(props)

        this.state = {
            user: true,
            plans: [],
            isLoading: true,
            modal: false,
            chosenPlan: '',
            planId: '',
        }

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.changePlan = this.changePlan.bind(this);
    }

    openModal(){
        const plan = document.getElementsByClassName("slick-current")[0].getElementsByClassName("plan")[0].innerHTML
        const plan_id = document.getElementsByClassName("slick-current")[0].getElementsByClassName("id")[0].innerHTML

        this.setState({
            modal: true,
            chosenPlan: plan,
            planId: plan_id
        })
    }

    closeModal(){
        this.setState({
            modal: false,
            chosenPlan: '',
            planId: ''
        })
    }

    componentDidMount(){

        pack.getAllPacks()
            .then((res) => {

            console.log(res)
            
            // Data
            let resData = res.data.data

            // Procura parametros na URL 
            const search = this.props.location.search;
            const pageId = new URLSearchParams(search).get("tag");
            
            // Caso venha o parâmetro de ID na URL

            if(pageId != null){
                // Filtra o que vier da URL (id)
                let filtered = resData.filter(function(item) { 

                    if(item.tag == pageId){

                        console.log(item.value)

                        localStorage.setItem("user_plan_name", item.name);
                        localStorage.setItem("user_plan_price", item.value);
                        localStorage.setItem("user_plan_id", item.id);
                        localStorage.setItem("user_plan_tag", item.tag)

                    }

                    return item.id != pageId;
                });

                let selectObj = {
                    "id": localStorage.getItem("user_plan_id"),
                    "tag": localStorage.getItem("user_plan_tag"),
                    "name": localStorage.getItem("user_plan_name"),
                    "value": localStorage.getItem("user_plan_price")
                }

                const orderedPlans = [selectObj].concat(filtered);

                this.setState({
                    plans: orderedPlans,
                    isLoading: false,
                });

            }else{

                this.setState({
                    plans: resData,
                    isLoading: false,
                });
                        
            }
            
            }).catch((err) => {
                console.log(err)
            })

        console.log(this.state.plans)

    }

    changePlan(){
        /* API */
        this.setState({isLoading: true});
        purchasedPack.changePurchasedPack(this.state.planId).then(response => {

            toastr.options = {
                positionClass : 'toast-top-full-width',
                hideDuration: 300,
                timeOut: 10000
            }
            toastr.clear();
            setTimeout(() => toastr.success(`Seu plano foi alterado com sucesso.`), 300);

            this.setState({isLoading: false});
            this.props.history.push('/dashboard');

        }).catch(error => {


            this.setState({
                isLoading: false,
                errorMessage: error.response.data.data.message
            });

            toastr.options = {
                positionClass : 'toast-top-full-width',
                hideDuration: 300,
                timeOut: 6000
            }
            toastr.clear()
            setTimeout(() => toastr.error(`${this.state.errorMessage}`), 300);

            this.props.history.push('/dashboard/plan/');
            
        });
    }

    render(){

        const sliderSettings = {
            className: "center",
            centerMode: true,
            infinite: true,
            centerPadding: "150px",
            slidesToShow: 1,
            initialSlide: 0,
            speed: 500,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 540,
                    settings: {
                        centerPadding: "30px",
                    }
                }
            ],
        }

        return(
            <div className="page-container page">
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className="modal"
                    open={this.state.modal}
                    onClose={this.closeModal}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                    timeout: 500,
                    }}
                >
                    <Fade in={this.state.modal}>
                        <div className="modalContent text-center">
                            <h2 className="modalTitle">
                                <AiFillWarning size="60px" /><br /><br />
                                ATENÇÃO</h2>
                            <div>
                                Tem certeza que deseja <strong>ALTERAR</strong> seu plano para o plano <strong>{this.state.chosenPlan}</strong>
                            </div>
                            <a className="btn-default mt-4 mb-4" onClick={this.closeModal}>Não e fechar</a><br />
                            <a className="link-default danger" onClick={this.changePlan}>Sim, desejo alterar!</a>
                        </div>
                    </Fade>
                </Modal>

                <div className="title">Dashboard</div>

                <SelectedPlan user={this.state.user} />

                <div className="position-relative">
                    <div className="p-5 text-center">

                        <h4>Planos disponíveis</h4>

                        {this.state.isLoading ? (
                            <LoadingComponent />
                        ) : (
                            <div className="pt-5">
                                <Slider ref={slider => (this.slider = slider)} {...sliderSettings}>
                                    {this.state.plans.map((plan) => {
                                        return (
                                            <div key={plan}>
                                                <div className='slick-plan'>
                                                    <small></small>
                                                    
                                                    <h2>
                                                        <span className="id">{plan.id}</span>
                                                        <span className="plan">{plan.name}</span> - R$
                                                        <span className="value">{plan.value.toLocaleString('pt-br', {minimumFractionDigits: 2}).substring(0,5)}</span>
                                                    </h2>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </Slider>
                            </div>
                        )}

                        <div className="row justify-content-center mt-4">
                            <a className="btn-default" onClick={() => this.openModal()} href="#">Confirmar alteração</a>
                        </div>


                    </div>
                </div>
            </div>
        )
    }

}

export default PlanChange;